module.exports = __webpack_public_path__ + "media/images/landkit/covers/cover-16-802455a01be3ea5377b1bc768b5b3162.jpg";